import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import styles from '../../styles/common/PrivacyModal.module.css';
import modalStyles from '../../styles/common/Modal.module.css';

interface PrivacyModalProps {
    show: boolean;
    onHide: () => void;
}

const PrivacyModal: React.FC<PrivacyModalProps> = ({
    show,
    onHide,
}) => {
    const brandName = process.env.REACT_APP_BRAND_NAME || "elPaket";

    return (
        <Modal
            show={show}
            onHide={onHide}
            centered
            size="lg"
            className={styles.privacyModal}
            contentClassName={styles.scaleIn}
            animation={false}
        >
            <Modal.Header closeButton>
                <Modal.Title as="h3" className={modalStyles.modalTitle}>
                    Política de Privacidad
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="privacy-content">
                    <p>
                        Esta Política de Privacidad describe cómo EnviarLatam LLC, operador de la marca comercial {brandName} ("la Empresa", "nosotros" o "nuestro"), recopila, utiliza, almacena, protege y comparte la información personal de los usuarios que acceden a nuestro sitio web o utilizan nuestros servicios de logística y transporte internacional.
                    </p>
                    <p>
                        Al utilizar nuestros servicios o navegar en nuestro sitio web, usted acepta las prácticas descritas en esta Política de Privacidad.
                    </p>

                    <h5>1. Información que Recopilamos</h5>
                    <p>Podemos recopilar información que usted nos proporciona directamente, incluyendo:</p>
                    <ul>
                        <li>Nombre y apellidos.</li>
                        <li>Dirección de correo electrónico.</li>
                        <li>Número de teléfono.</li>
                        <li>Dirección física.</li>
                        <li>Documento de identificación cuando sea requerido por la legislación aplicable.</li>
                        <li>Información del remitente y destinatario.</li>
                        <li>Información sobre los envíos, incluyendo descripción, peso y valor declarado de la mercancía.</li>
                        <li>Información de facturación y pagos.</li>
                        <li>Cualquier otra información que usted decida proporcionarnos para la prestación de nuestros servicios.</li>
                    </ul>
                    <p>Asimismo, nuestro sitio web puede recopilar automáticamente cierta información técnica, como:</p>
                    <ul>
                        <li>Dirección IP.</li>
                        <li>Tipo de navegador.</li>
                        <li>Sistema operativo.</li>
                        <li>Páginas visitadas.</li>
                        <li>Fecha y hora de acceso.</li>
                        <li>Información sobre el dispositivo utilizado.</li>
                    </ul>

                    <h5>2. Finalidad del Tratamiento de la Información</h5>
                    <p>La información recopilada podrá utilizarse para:</p>
                    <ul>
                        <li>Prestar los servicios solicitados.</li>
                        <li>Procesar y administrar envíos.</li>
                        <li>Gestionar entregas nacionales e internacionales.</li>
                        <li>Cumplir con requisitos aduaneros y regulatorios.</li>
                        <li>Emitir facturas y procesar pagos.</li>
                        <li>Brindar soporte al cliente.</li>
                        <li>Enviar notificaciones relacionadas con los envíos.</li>
                        <li>Mejorar nuestros servicios y el funcionamiento del sitio web.</li>
                        <li>Detectar y prevenir actividades fraudulentas o ilícitas.</li>
                        <li>Cumplir obligaciones legales y regulatorias.</li>
                    </ul>

                    <h5>3. Base para el Tratamiento de los Datos</h5>
                    <p>Tratamos la información personal únicamente cuando existe una base legal para hacerlo, incluyendo:</p>
                    <ul>
                        <li>La ejecución del contrato de prestación de servicios.</li>
                        <li>El cumplimiento de obligaciones legales.</li>
                        <li>Nuestro interés legítimo en operar y mejorar nuestros servicios.</li>
                        <li>El consentimiento del usuario cuando sea requerido.</li>
                    </ul>

                    <h5>4. Compartición de la Información</h5>
                    <p>La Empresa no vende ni comercializa información personal.</p>
                    <p>Sin embargo, podremos compartir información con:</p>
                    <ul>
                        <li>Empresas transportistas y operadores logísticos.</li>
                        <li>Autoridades aduaneras y organismos gubernamentales.</li>
                        <li>Proveedores tecnológicos y de alojamiento de datos.</li>
                        <li>Procesadores de pagos.</li>
                        <li>Asesores legales, contables o auditores.</li>
                        <li>Autoridades competentes cuando así lo exija la ley.</li>
                    </ul>
                    <p>Toda divulgación se realizará únicamente cuando sea necesaria para la prestación del servicio o por obligación legal.</p>

                    <h5>5. Conservación de la Información</h5>
                    <p>La información personal será conservada durante el tiempo necesario para:</p>
                    <ul>
                        <li>prestar los servicios contratados;</li>
                        <li>cumplir obligaciones legales;</li>
                        <li>atender reclamaciones;</li>
                        <li>resolver controversias;</li>
                        <li>mantener registros comerciales conforme a la legislación aplicable.</li>
                    </ul>
                    <p>Una vez finalizado dicho período, la información será eliminada o anonimizada cuando corresponda.</p>

                    <h5>6. Seguridad de la Información</h5>
                    <p>EnviarLatam LLC implementa medidas técnicas, administrativas y organizativas razonables para proteger la información personal contra pérdida, uso indebido, acceso no autorizado, alteración o divulgación.</p>
                    <p>Aunque adoptamos medidas de seguridad apropiadas, ningún sistema de transmisión o almacenamiento electrónico puede garantizar una seguridad absoluta.</p>

                    <h5>7. Cookies y Tecnologías Similares</h5>
                    <p>Nuestro sitio web utiliza cookies y tecnologías similares para:</p>
                    <ul>
                        <li>permitir el correcto funcionamiento del sitio;</li>
                        <li>recordar preferencias del usuario;</li>
                        <li>mejorar la experiencia de navegación;</li>
                        <li>analizar el uso del sitio web;</li>
                        <li>optimizar nuestros servicios.</li>
                    </ul>
                    <p>El usuario puede configurar su navegador para rechazar o eliminar las cookies; sin embargo, algunas funcionalidades del sitio podrían verse afectadas.</p>

                    <h5>8. Enlaces a Sitios de Terceros</h5>
                    <p>Nuestro sitio web puede contener enlaces a páginas de terceros.</p>
                    <p>EnviarLatam LLC no es responsable de las prácticas de privacidad ni del contenido de dichos sitios externos.</p>

                    <h5>9. Privacidad de Menores</h5>
                    <p>Nuestros servicios no están dirigidos a menores de dieciocho (18) años.</p>
                    <p>No recopilamos deliberadamente información personal de menores. Si detectamos que se ha recopilado información de un menor sin la autorización correspondiente, procederemos a eliminarla tan pronto como sea razonablemente posible.</p>

                    <h5>10. Cambios a esta Política</h5>
                    <p>EnviarLatam LLC podrá modificar esta Política de Privacidad en cualquier momento.</p>
                    <p>La versión vigente será la publicada en este sitio web e indicará la fecha de su última actualización.</p>
                    <p>El uso continuado de nuestros servicios después de la publicación de cambios constituirá la aceptación de la versión actualizada.</p>

                    <h5>11. Contacto</h5>
                    <p>Si tiene preguntas sobre esta Política de Privacidad o desea ejercer alguno de sus derechos relacionados con el tratamiento de sus datos personales, puede comunicarse con EnviarLatam LLC a través de los canales oficiales publicados en este sitio web.</p>
                </div>
            </Modal.Body>

            <Modal.Footer>
                <Button
                    variant="primary"
                    onClick={onHide}
                    className={modalStyles.closeBtn}
                >
                    Aceptar y Cerrar
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default PrivacyModal;
